export default function IconMaleFemale() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-39fc6c29-800d-4d35-8c2a-dcb5f9985435"
      data-name="Layer 2"
      viewBox="0 0 61.761 61.811"
    >
      <defs>
        <style />
      </defs>
      <g id="uuid-3710f0ef-a1c8-40eb-8058-16d212b83c6e" data-name="Layer 1">
        <g id="uuid-07c163df-a8e9-4eec-b13f-6e3d16250d36" data-name="g594">
          <g id="uuid-f4f5115b-672e-48e1-80eb-075952d2c138" data-name="g596">
            <g id="uuid-44df4431-9a5e-4384-918d-0fbd1c886bbb" data-name="g598">
              <path
                id="uuid-8fa98b90-f821-43a0-9f9d-ea2b6b539e46"
                d="M16.358 42.059C7.338 42.059 0 34.72 0 25.7S7.338 9.341 16.358 9.341s16.359 7.34 16.359 16.36-7.339 16.358-16.359 16.358Zm0-29.096c-7.023 0-12.736 5.714-12.736 12.737s5.713 12.737 12.736 12.737S29.095 32.723 29.095 25.7 23.38 12.963 16.358 12.963Z"
                data-name="g604"
              />
              <path
                id="uuid-7e82b14e-084c-4b65-9c18-b9c5ff8bb140"
                d="M14.547 40.248h3.622v21.564h-3.622z"
                data-name="g608"
              />
              <path
                id="uuid-14fd1a22-8cae-47c5-af45-3178940f7692"
                d="M9.664 52.126h13.39v3.622H9.664z"
                data-name="g612"
              />
              <path
                id="uuid-a59efe42-b137-4b50-8603-4ad72ee95025"
                d="M36.061 42.059c-9.02 0-16.358-7.339-16.358-16.359S27.04 9.341 36.06 9.341s16.358 7.34 16.358 16.36S45.08 42.059 36.06 42.059Zm0-29.096c-7.023 0-12.736 5.714-12.736 12.737s5.713 12.737 12.736 12.737S48.797 32.723 48.797 25.7s-5.713-12.737-12.736-12.737Z"
                data-name="g616"
              />
              <path
                id="uuid-bcd45e3e-e9a0-4465-a2ca-7bfe970087fe"
                d="M43.531 6.802h19.237v3.621H43.531z"
                data-name="g620"
                transform="rotate(-45 53.149 8.612)"
              />
              <path
                id="uuid-c6e0cd56-6f6c-4234-8fa1-63a1f4e6ba66"
                d="M61.761 13.354H58.14V3.623h-9.732V0H61.76v13.354z"
                data-name="g624"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
